import * as React from 'react';

const Caret = ({fillColor = '#2961fa'}) => (
  <svg
    data-name="Group 233936"
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={14}
    viewBox="0 0 10.392 17.363">
    <rect
      data-name="Rectangle 14948"
      width={12.219}
      height={2.478}
      rx={1.239}
      transform="rotate(45 .876 2.115)"
      fill={fillColor}
    />
    <rect
      data-name="Rectangle 14949"
      width={12.219}
      height={2.478}
      rx={1.239}
      transform="rotate(135 3.39 6.514)"
      fill={fillColor}
    />
  </svg>
);

export default Caret;
